import { apiGet } from '../_common';

export default {
  search(query) {
    return apiGet('/magenta/stock/entry/type', query).then(result => result.response);
  },
};
